export default __webpack_public_path__ + "static/compareItemImg2-7e15a217fd6537572a2edd0dc77f69d9.webp";